/** O‘zbekcha — navigatsiya, footer, cookie, 404 */
export const layoutUz: Record<string, string> = {
  "nav.logoAria": "IT-24.pro bosh sahifaga",
  "nav.devops": "Xizmatlar",
  "nav.admin": "Audit",
  "nav.support": "Shoshilinch yordam",
  "nav.vps": "Aloqa",
  "nav.k8s": "Loyihalar",
  "nav.cicd": "Keyslar",
  "nav.ddos": "Men haqimda",
  "nav.llmops": "Retainer",
  "nav.packages": "Xizmatlar",
  "nav.audience": "Kimlar uchun",
  "nav.cases": "Keyslar",
  "nav.portfolio": "Keyslar",
  "nav.contacts": "Aloqa",
  "nav.auditCta": "Telegramga yozish",
  "nav.auditCtaShort": "Telegram",
  "nav.ariaMain": "Asosiy navigatsiya",
  "nav.langSwitcherAria": "Sayt tili",
  "nav.menuOpen": "Navigatsiya menyusini ochish",
  "nav.menuClose": "Menyuni yopish",
  "nav.langRu": "RU",
  "nav.langUk": "UA",
  "nav.langKk": "KZ",
  "nav.langUz": "UZ",
  "nav.langKy": "KG",

  "footer.tagline":
    "Ayirboshlash, to‘lov va highload infratuzilmasi. Polsha yuridik shaxsi · Telegram.",
  "footer.badge1": "✓ PCI / DDoS / K8s",
  "footer.badge2": "✓ USDT / invoys",
  "footer.badge3": "✓ 2010-yildan infratuzilmada",
  "footer.consultCta": "Telegramga yozish",
  "footer.servicesTitle": "Xizmatlar",
  "footer.tariffsHome": "Bosh sahifadagi xizmatlar",
  "footer.devops": "DevOps retainer",
  "footer.serverSupport": "Shoshilinch yordam",
  "footer.serverAdmin": "Audit",
  "footer.k8s": "PCI / DDoS / K8s loyihalari",
  "footer.cicd": "Keyslar",
  "footer.ddos": "Men haqimda",
  "footer.llmops": "Aloqa",
  "footer.vps": "nexops.eu (EU)",
  "footer.vacancies": "Telegram",
  "footer.contactTitle": "Aloqa",
  "footer.location": "Konin, Poland",
  "footer.copy": "Barcha huquqlar himoyalangan.",
  "footer.taglineBottom": "Ayirboshlash · fintech · highload · Telegram",

  "cookie.title": "Saytdan qulay foydalanish uchun cookie ishlatamiz",
  "cookie.body":
    "Cookie fayllari navigatsiya va ba’zi funksiyalar uchun kerak. Saytda qolsangiz, bunga rozilik bildirgan bo‘lasiz.",
  "cookie.reject": "Rad etish",
  "cookie.accept": "Qabul qilish",

  "notFound.title": "Sahifa topilmadi | IT-24.pro",
  "notFound.description":
    "Bunday sahifa yo‘q. Ayirboshlash va fintech infratuzilmasi — bosh sahifada.",
  "notFound.h1": "Sahifa topilmadi",
  "notFound.text":
    "Havola eskirgan bo‘lishi mumkin — eski xizmatlar yangi bo‘limlarga ko‘chirilgan.",
  "notFound.home": "Bosh sahifaga",
  "notFound.devops": "Retainer / xizmatlar",

  "breadcrumb.home": "Bosh sahifa",
  "breadcrumb.devopsServices": "Xizmatlar",
  "breadcrumb.ariaLabel": "Navigatsiya zanjiri",

  "search.title": "Sayt bo‘yicha qidiruv | IT-24.pro",
  "search.titleWithQuery": "Qidiruv: {query} | IT-24.pro",
  "search.description": "IT-24.pro xizmatlarini qidiring: retainer, audit, PCI, DDoS, Kubernetes.",
  "search.h1": "Sayt bo‘yicha qidiruv",
  "search.lead": "Xizmatni toping: shoshilinch yordam, audit, retainer, loyihalar.",
  "search.placeholder": "Masalan: pci, ddos, retainer",
  "search.submit": "Qidirish",
  "search.prompt": "So‘rov yozing — mos bo‘limlarni ko‘rsatamiz.",
  "search.resultsCount": "Topildi: {count}",
  "search.noResults": "«{query}» bo‘yicha hech narsa topilmadi.",
  "search.emptyHint": "Boshqa kalit so‘zlarni sinang yoki xizmatlarga o‘ting.",
};
